import { useContext, useEffect } from 'react';
import { DashboardContext } from '../context/DashboardContext';
import { useAuth } from './useAuth';

export const useDashboard = () => {
  const context = useContext(DashboardContext);
  const { user } = useAuth();
  
  if (!context) {
    throw new Error('useDashboard debe ser usado dentro de un DashboardProvider');
  }
  
  const {
    dashboardData,
    isLoading,
    hasError,
    error,
    fetchDashboard,
    refreshDashboard
  } = context;

  // Cargar datos automáticamente cuando el componente se monta
  useEffect(() => {
    if (user && user.farmacia_id) {
      fetchDashboard(user.farmacia_id);
    }
  }, [user, fetchDashboard]);

  return {
    data: dashboardData,
    loading: isLoading,
    error: hasError ? error : null,
    refetch: () => user && user.farmacia_id && refreshDashboard(user.farmacia_id)
  };
};

export default useDashboard;

// Made with Bob
